import classnames from 'classnames';
import {
  ArticlePromoBlock as V3ArticlePromoBlock,
  ArticlePromoBlockProps,
} from '@stadionhq-v3/base-ui';
import styles from './articlePromoBlock.module.scss';

export const ArticlePromoBlock = ({
  ctaButton,
  ...props
}: ArticlePromoBlockProps) => {
  const classes = classnames([
    styles.articlePromoBlockTokens,
    styles.articlePromoBlock,
  ]);

  return (
    <V3ArticlePromoBlock
      classNames={[classes]}
      {...props}
      ctaButton={
        ctaButton && {
          ...ctaButton,
          classNames: [
            classnames(
              ctaButton.classNames,
              styles.buttonTokens,
              styles.button,
              styles.textButton,
              styles.ctaButton,
              styles.medium
            ),
          ],
        }
      }
    />
  );
};
